<template>
  <div id="researchReport">
    <bread :content="breadContent"></bread>
    <p class="Page-title">研究报告</p>
    <el-divider></el-divider>
    <div class="container">
      <researchCard :data="item" v-for="(item, index) in researchCardData" :key="index"></researchCard>
    </div>
  </div>
</template>

<script>
import bread from '@/components/bread';
import researchCard from '@/components/studyResult/researchCard'
import Api from '@/network.js'

export default {
  name: 'researchReport',
    data() {
    return {
      breadContent: [
        {text:'首页', routerName:'index'},
        {text:'研究成果', routerName:'studyResult'},
        {text:'研究报告', routerName:'researchReport'},
      ],
      researchCardData: []
    }
  },
  components: {
    researchCard,
    bread
  },
  methods: {
    setData(obj) {
      // 将obj与this.data合并
      Object.assign(this.$data, obj)
    }
  },
  async beforeRouteEnter (to, from, next) {
    const PER_COUNT = 4 
    const res = await Api.studyResult.getResearchReport()||[]
    let data = [], sub = []
    res.forEach((item, index) => {
      sub.push({
        title: item.Title,
        author: item.Author,
        date: item.Date,
        id: item.Id
      })
      if (index % PER_COUNT === PER_COUNT - 1) {
        data.push(sub)
        sub = []
      }
    })
    if (res.length % PER_COUNT !== 0) {
      // 剩下未满 PER_COUNT 的数据
      data.push(sub)
    }
    next(vm => vm.setData({researchCardData: data}))
  },
  // async created() {
  //   this.researchCardData = data
  // },
}
</script>

<style lang="scss" scoped>
  #researchReport {
    width: calc(100% - 250px);
    margin-left: 50px;
    margin-top: 40px;
  }
  .container {
    padding-top: 10px;
    .researchCard {
      margin-bottom: 45px;
    }
  }
</style>
